import { css } from "styled-components";

export const CollapsibleCardCss = css`
    .collapsible-card {
        .ant-card-body {
            padding: 10px 12px;

            .title-text {
                font-weight: 500;
            }

            .title-icon {
                margin-right: 12px;
                font-size: 1rem;
                color: rgba(0,0,0,60%);
            }
        }
        

        &.close {
            cursor: pointer; 
            transition: background 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

            &:hover {
                background: #ffe7ba;
                border: 1px solid #ffd591;
            }
        }

        &.open {

        }

        .collapsible-card-open-title-row {
            cursor: pointer;
        }
        
        .addon-info-div {
            margin-right: 10px;
            font-weight: 500;
            color: rgba(0,0,0,60%);
        }
    }
`;
